import {React,useState ,useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules'; // Corrected import for Pagination module
import './ImageSlider.css'; // Custom styles

const getImages = (folder) => {
  const usedFolder = folder && typeof folder === 'string' && folder.trim() ? folder : 'slider-photos';
  return [
    {
      desktop: `/${usedFolder}/frame_1.jpg`,
      mobile: `/${usedFolder}/frame_1_mob.jpg`
    },
    {
      desktop: `/${usedFolder}/frame_2.jpg`,
      mobile: `/${usedFolder}/frame_2_mob.jpg`
    },
    {
      desktop: `/${usedFolder}/frame_3.jpg`,
      mobile: `/${usedFolder}/frame_3_mob.jpg`
    },
    {
      desktop: `/${usedFolder}/frame_4.jpg`,
      mobile: `/${usedFolder}/frame_4_mob.jpg`
    },
    {
      desktop: `/${usedFolder}/frame_5.jpg`,
      mobile: `/${usedFolder}/frame_5_mob.jpg`
    }
  ];
};

const ImageSlider = ({ folder }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const images = getImages(folder);

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="slider-container">
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        pagination={{ clickable: true }}
        modules={[Pagination]}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={screenWidth > 768 ? image.desktop : image.mobile}
              alt={`Slide ${index}`}
              className="slider-image"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageSlider;
